import React from 'react';
import { UserModel } from '../../UsersTable';
import { SubscriptionChange } from './SelectSubscription';

interface SelectAmountProps {
  user: UserModel,
  amount: string,
  subscription: SubscriptionChange,
  subscriptionSkipped: boolean
}

export const ConfirmCheck = (props: SelectAmountProps) => {

  return (
    <div>
      <div>
        <h3>Informations du client:</h3>
        <ul>
          <li>Adresse e-mail: {props.user.email}</li>
          <li>Numéro client: {props.user.id}</li>
        </ul>
      </div>
      <div>
        <h3>Enregistrement d'un chèque d'une valeur de:</h3>
        <ul>
          <li>{props.amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}€</li>
        </ul>
      </div>
      <div>
        <h3>Mise à jour de l'abonnement:</h3>
        {!props.subscriptionSkipped ?
          (
            <ul>
              <li>Type d'abonnement: {props.subscription.role}</li>
              <li>Date de fin: {props.subscription.endDate.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</li>
            </ul>
          ) : (
            <>
              L'abonnement reste inchangé.
            </>
          )
        }
      </div>
    </div>
  );
}